import { context } from '../constants/context';
import { halClient } from '../hal';
import { BBModel } from '../bb_model';
import { BBService } from '../bb_service';
import { bbAuthorisation } from '../admin/bb_authorisation';
import { Utils } from '../utils/utils';

const adminCompany = {
    query(params) {
        return new Promise((resolve, reject) => {

            BBService.adminLogin.checkUser().then(() => {
                if (bbAuthorisation.getUser() && bbAuthorisation.getUser().company_id) {

                    if (params.companyId) {
                        if (BBModel.Admin.Company.all[params.companyId]) {
                            return resolve(BBModel.Admin.Company.all[params.companyId]);
                        }

                        const uri = context.apiUrl + `/api/${context.apiVersion}/admin/${params.companyId}/company`;
                        return halClient.$get(uri, {})
                            .then((response) => {
                                const company = new BBModel.Admin.Company(response);
                                BBModel.Admin.Company.all[company.id] = company;
                                resolve(company);
                            }, reject);
                    }

                    return bbAuthorisation.getUser().$get('company')
                        .then(company => resolve(new BBModel.Admin.Company(company)), err => reject(err));

                } else {

                    //TODO login when trying to search ??
                    if (!params.adminEmail || !params.adminPassword) {
                        reject();
                        return;
                    }

                    const login_form = {
                        email: params.adminEmail,
                        password: params.adminPassword
                    };
                    const options =
                        { company_id: params.companyId };

                    return BBService.adminLogin.login(login_form, options).then(user =>
                            user.$get('company').then(company => resolve(new BBModel.Admin.Company(company))
                                , err => reject(err))

                        , err => reject(err));
                }
            });
        });
    },

    /**
     * @deprecated This method has been deprecated and the {@link search} method should be used instead
     * @param params {object} Parameters used for the search
     * @param params.companyId {number} The id of the company to search within
     * @param params.searchValue {string} The search term to use, can be either name, reference or ID.
     * @returns {Promise<AdminCompanyModel[]>}
     */
    searchChildren(params) {
        const uri = `${context.apiUrl}/api/${context.apiVersion}/admin/${params.companyId}/company/search?company[text]=${params.searchValue}`;
        return halClient.$get(uri, {}).then(this.handleCompanySearchResponse);
    },

    /**
     * Processes the company search response and returns an array of admin company models if there are any returned.
     * @param result {BaseResource} The company search response
     * @returns {Promise<AdminCompanyModel[]>|Promise<void>}
     */
    handleCompanySearchResponse(result) {
        if (result.$has('companies')) {
            return result.$get('companies').then((companyBaseResources) => {
                return companyBaseResources.map(company => new BBModel.Admin.Company(company));
            });
        } else {
            return Promise.resolve();
        }
    },

    /**
     * Search for children of the specified company.
     * @param params {object} Params that should be added to the url.
     * @param params.company[text] {string} The search term to use, can be either name, reference or ID.
     * @param params.page {number} Which page to get
     * @param params.per_page {number} How many items per page
     * @param params.strategy {string} The search can return different results based on this:
     * 'children' - only search direct children of the company
     * 'descendants' - search the entire company hierarchy
     * 'leafs' - only search companies that have no children
     * @param companyId {number} The company to which the children belong.
     * @returns {Promise<BaseResource>}
     */
    async search(params, companyId) {
        // Support the old style of chucking everything in the params just in case...
        if (params.companyId) {
            companyId = params.companyId;
            delete params.companyId;
        }

        if (params.searchValue && !params['company[text]']) {
            params['company[text]'] = params.searchValue;
            delete params.searchValue;
        }

        const queryString = Utils.objectToUrlSearch(params);

        const uri = `${context.apiUrl}/api/${context.apiVersion}/admin/${companyId}/company/search${queryString}`;
        return halClient.$get(uri, {});
    },

    /**
     * Retrieve direct children of the specified company
     * @param params {object} Params that should be added to the url.
     * @param params.company[text] {string} The search term to use, can be either name, reference or ID.
     * @param params.page {number} Which page to get
     * @param params.per_page {number} How many items per page
     * @param params.order_by[key] {string} Allowed options are order_by[name], order_by[api_ref] or order_by[id] and asc / desc
     * @param companyId {number} The company to which the children belong.
     * @returns {Promise<BaseResource>}
     */
    async children(params, companyId) {
        const queryString = Utils.objectToUrlSearch(params);

        const uri = `${context.apiUrl}/api/${context.apiVersion}/admin/${companyId}/company/children${queryString}`;
        return halClient.$get(uri, {});
    }
};

export {
    adminCompany
};